import Vue from 'vue'
import * as moment from 'moment'
import * as Html from '../utils/html'

Vue.filter('momentFormat', (value, format = 'YYYY-MM-DD HH:mm:ss') => {
    let m = moment(value);
    return (value && m.isValid()) ? m.format(format) : '-';
});

Vue.filter('contentHtml', Html.format);

Vue.filter('percentFilter',
    value => (Number.isFinite(value) || (typeof(value) === "string" && value.trim() !== "")) ? (value + "%") : "",
);

function getFixed(value, precision) {
    if (value === null || value === void(0) || (typeof(value) === "string" && value.trim() === "")) {
        return "";
    } else if (Number.isFinite(value) || (typeof(value) === "string" && Number.isFinite(+value))) {
        return (+value).toFixed(precision);
    } else {
        return value;
    }
}

Vue.filter('fixedNumber', (value, precision = 2) => getFixed(value, precision));

Vue.filter('roundNumber', (value, precision = 2) => {
    let result = getFixed(value, precision);
    if (typeof(result) === "string" && Number.isFinite(+value)) {
        return (+result).toString();
    } else {
        return result;
    }
});

Vue.filter('dateDesc', (value) => {
    let date = moment(value).startOf("day");
    let days = moment().startOf("day").diff(date, "day");
    if (0 === days) {
        return "今天";
    } else if (1 === days) {
        return "昨天";
    } else if (2 === days) {
        return "前天";
    } else if (-1 === days) {
        return "明天";
    } else if (-2 === days) {
        return "后天";
    } else if (Math.abs(days) <= 10) {
        return `${Math.abs(days)}天${days > 0 ? '前' : '后'}`;
    } else {
        return date.format("MM月DD日");
    }
});

Vue.filter('timeDesc', (value) => {
    let time = moment(value);
    let minutes = moment().diff(time, "minute");
    if (0 === minutes) {
        return "1分钟内";
    } else if (minutes < 60) {
        return `${minutes}分钟前`;
    } else {
        let hours = Math.floor(minutes / 60);
        if (hours < 24) {
            return `${hours}小时前`;
        } else {
            let days = Math.floor(hours / 24);
            return `${days}天前`;
        }
    }
});
